/**
 * Constantes liées aux questionnaires
 * Source de vérité unique — miroir du schéma Prisma
 */

export const QuestionnaireFormationType = {
  AVANT: 'avant',
  A_CHAUD: 'a_chaud',
  A_FROID: 'a_froid',
  DEMANDEUR: 'demandeur',
  FINANCEUR: 'financeur',
}

export const QUESTIONNAIRE_TYPE_LABELS = {
  [QuestionnaireFormationType.AVANT]: 'Avant formation',
  [QuestionnaireFormationType.A_CHAUD]: 'À chaud',
  [QuestionnaireFormationType.A_FROID]: 'À froid',
  [QuestionnaireFormationType.DEMANDEUR]: 'Demandeur',
  [QuestionnaireFormationType.FINANCEUR]: 'Financeur',
}

export const QUESTIONNAIRE_TYPE_OPTIONS = [
  { value: '', label: '-- Type --' },
  ...Object.entries(QUESTIONNAIRE_TYPE_LABELS).map(([value, label]) => ({ value, label })),
]

export const QUESTIONNAIRE_TYPE_VARIANTS = {
  [QuestionnaireFormationType.AVANT]: 'info',
  [QuestionnaireFormationType.A_CHAUD]: 'warning',
  [QuestionnaireFormationType.A_FROID]: 'success',
  [QuestionnaireFormationType.DEMANDEUR]: 'admin',
  [QuestionnaireFormationType.FINANCEUR]: 'secondary',
}

export const QuestionnaireEnvoiStatut = {
  EN_ATTENTE: 'en_attente',
  ENVOYE: 'envoye',
  OUVERT: 'ouvert',
  COMPLETE: 'complete',
  EXPIRE: 'expire',
}

export const QUESTIONNAIRE_STATUS_LABELS = {
  [QuestionnaireEnvoiStatut.EN_ATTENTE]: 'En attente',
  [QuestionnaireEnvoiStatut.ENVOYE]: 'Envoyé',
  [QuestionnaireEnvoiStatut.OUVERT]: 'Ouvert',
  [QuestionnaireEnvoiStatut.COMPLETE]: 'Complété',
  [QuestionnaireEnvoiStatut.EXPIRE]: 'Expiré',
}

export const QUESTIONNAIRE_STATUS_VARIANTS = {
  [QuestionnaireEnvoiStatut.EN_ATTENTE]: 'secondary',
  [QuestionnaireEnvoiStatut.ENVOYE]: 'info',
  [QuestionnaireEnvoiStatut.OUVERT]: 'warning',
  [QuestionnaireEnvoiStatut.COMPLETE]: 'success',
  [QuestionnaireEnvoiStatut.EXPIRE]: 'devis_perdu',
}

export const QuestionnaireStatut = {
  BROUILLON: 'brouillon',
  ENVOYE: 'envoye',
  SOUMIS: 'soumis',
  VALIDE: 'valide',
}

export const QuestionType = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  INFO: 'info',
  RATING: 'rating',
  SCALE: 'scale',
  NPS: 'nps',
}

export function getTypeVariant(type) {
  return QUESTIONNAIRE_TYPE_VARIANTS[type] || 'info'
}

export function getStatusVariant(statut) {
  return QUESTIONNAIRE_STATUS_VARIANTS[statut] || 'secondary'
}

export function getNpsClass(score) {
  if (score <= 6) return 'detractor'
  if (score <= 8) return 'passive'
  return 'promoter'
}
